import { OrgLevel } from "../../model";

import * as actions from "./actionTypes";
import { PhysiotherapyReferralFormState } from "./models";
import { PhysiotherapyReferralFormAction } from "./actions";

const defaultState: PhysiotherapyReferralFormState = { orgLevels: [] };

export function reducer(state: PhysiotherapyReferralFormState = defaultState, action: PhysiotherapyReferralFormAction): PhysiotherapyReferralFormState {
    switch (action.type) {
        case actions.LOAD_ORG_STRUCTURES_SUCCESS: {
            const newOrgLevels = action.payload.filter((orgLevel: OrgLevel) => !state.orgLevels.find(l => l.id === orgLevel.id));
            return { ...state, orgLevels: [...state.orgLevels, ...newOrgLevels] };
        }
        default: {
            return state;
        }
    }
}
